import React from 'react'
import { useNavigation } from 'msp-integrations'
import Button from '@atoms/Button/Button'

const ButtonWrapper = ({ data, custom }: { data: any; custom: any }) => {
  const navigate = useNavigation()

  const {
    buttonText,
    buttonType,
    buttonVariant,
    iconName = '',
    iconPosition
  } = data
  const { buttonLink = '' } = custom.content

  const isExternal = buttonLink.includes('http')

  const setLocation = () => {
    if (typeof window !== 'undefined') {
      window.location.href = buttonLink
    }
  }

  return (
    <Button
      onClick={() => (isExternal ? setLocation() : navigate(buttonLink))}
      type={buttonType}
      variant={buttonVariant}
      iconName={iconName}
      iconPosition={iconPosition}
    >
      {buttonType !== 'tertiary' && buttonText}
    </Button>
  )
}

export default ButtonWrapper
